import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Heart } from "lucide-react";
import { toast } from "sonner";

const HERO_IMG = "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yJTIwbHV4dXJ5fGVufDB8fHx8MTc4NTI3MzAyNXww&ixlib=rb-4.1.0&q=85";

export default function Register() {
  const { register } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) { toast.success("You're in! Welcome to Host Hustle."); nav("/dashboard"); }
    else toast.error(res.error);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-white">
      <div className="flex items-center justify-center p-6 lg:p-12 order-2 lg:order-1">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="register-form">
          <div className="uppercase tracking-[0.28em] text-xs text-brand-pink mb-3">Create Account</div>
          <h1 className="font-display text-4xl mb-8">Start hosting smarter.</h1>
          <div className="space-y-5">
            <div>
              <Label className="mb-2 block">Full Name</Label>
              <Input data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="rounded-full h-12 px-5 border-neutral-200" />
            </div>
            <div>
              <Label className="mb-2 block">Email</Label>
              <Input data-testid="register-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-full h-12 px-5 border-neutral-200" />
            </div>
            <div>
              <Label className="mb-2 block">Password</Label>
              <Input data-testid="register-password" type="password" minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} required className="rounded-full h-12 px-5 border-neutral-200" />
              <div className="text-xs text-neutral-400 mt-2">At least 6 characters.</div>
            </div>
          </div>
          <Button disabled={loading} type="submit" size="lg" data-testid="register-submit" className="w-full mt-8 rounded-full bg-brand-pink hover:bg-brand-pink/90 text-white btn-pink-glow">
            {loading ? "Creating…" : "Join Host Hustle"}
          </Button>
          <p className="text-sm text-neutral-500 mt-6 text-center">
            Already a member? <Link to="/login" className="text-brand-pink font-medium">Log in</Link>
          </p>
        </form>
      </div>
      <div className="hidden lg:block relative order-1 lg:order-2">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 h-full flex flex-col justify-between p-12 text-white">
          <Link to="/" className="flex items-center gap-2 justify-end">
            <div className="font-display text-2xl text-right">Host <span className="font-script text-brand-pink">Hustle</span></div>
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 backdrop-blur">
              <Heart className="w-4 h-4 text-brand-pink" fill="#E91E63" />
            </span>
          </Link>
          <div className="text-right">
            <div className="font-script text-3xl text-brand-pink mb-3">Let's hustle smarter</div>
            <div className="font-display text-4xl leading-tight">Your Airbnb business<br/>starts today.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
